import { Button, Input, Modal, Popconfirm, Tag, message } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { isValidVnMobile, normalizePhone } from "../../../utils/utilsBirthday";
import {
	PHONE_REASONS,
	REASON_TEXT,
	findCustomerByMa,
	getThuTienZns,
	sendThuTienZns,
} from "../../../utils/utilsThuTien";

const getHeaders = () => ({
	"X-Access-Token": localStorage.getItem("token"),
	"Content-Type": "application/json",
});

// Ô "ZNS" của phiếu thu: trạng thái gửi thông báo thu tiền + gửi lại / sửa SĐT.
export default function ZnsThuTienCell({ record, messageApi }) {
	const notify = messageApi?.open ? messageApi : message;
	const [exfields, setExfields] = useState(record?.exfields);
	const [sending, setSending] = useState(false);
	const [editingPhone, setEditingPhone] = useState(null);
	const [phoneInput, setPhoneInput] = useState("");
	const [savingPhone, setSavingPhone] = useState(false);

	useEffect(() => {
		setExfields(record?.exfields);
	}, [record?.exfields]);

	const { status, reason, at } = getThuTienZns({ exfields });
	const atText = at ? dayjs(at).format("DD/MM/YYYY HH:mm") : "";

	const handleSend = async () => {
		setSending(true);
		try {
			const result = await sendThuTienZns(record?._id);
			if (result.status === "disabled") {
				notify.open({
					type: "warning",
					content:
						"Chưa cấu hình link_webhook_thu_tien, vào /setting để nhập link",
				});
				return;
			}
			if (result.exfields) setExfields(result.exfields);
			if (result.status === "sent") {
				notify.open({ type: "success", content: "Đã gửi ZNS cho khách" });
				if (result.saved === false) {
					notify.open({
						type: "warning",
						content: "Đã gửi nhưng chưa ghi được trạng thái vào phiếu thu",
					});
				}
			} else {
				notify.open({
					type: "warning",
					content: `Chưa gửi được ZNS: ${
						REASON_TEXT[result.reason] || "gửi thất bại"
					}`,
				});
			}
		} finally {
			setSending(false);
		}
	};

	const openEditPhone = async () => {
		try {
			const customer = await findCustomerByMa(record?.ma_kh);
			if (!customer) {
				notify.open({
					type: "error",
					content: "Không tìm thấy hồ sơ khách",
				});
				return;
			}
			setEditingPhone(customer);
			setPhoneInput(customer.dien_thoai || "");
		} catch (e) {
			console.log(e);
			notify.open({ type: "error", content: "Không tải được hồ sơ khách" });
		}
	};

	const handleSavePhoneAndSend = async () => {
		if (!isValidVnMobile(phoneInput)) {
			notify.open({
				type: "error",
				content: "SĐT không hợp lệ (cần số di động Việt Nam 10 số)",
			});
			return;
		}
		setSavingPhone(true);
		try {
			await request.put(
				`api/${localStorage.getItem("id_app")}/customer/${editingPhone._id}`,
				{ _id: editingPhone._id, dien_thoai: normalizePhone(phoneInput) },
				{ headers: getHeaders() },
			);
			notify.open({ type: "success", content: "Đã cập nhật SĐT" });
			setEditingPhone(null);
		} catch (e) {
			console.log(e);
			notify.open({ type: "error", content: "Cập nhật SĐT thất bại" });
			setSavingPhone(false);
			return;
		}
		setSavingPhone(false);
		await handleSend();
	};

	return (
		<div
			className="flex flex-col gap-1 items-start"
			onClick={(e) => e.stopPropagation()}
		>
			{status === "sent" ? (
				<Tag color="green" title={atText}>
					Đã gửi {atText && `(${atText})`}
				</Tag>
			) : status === "failed" ? (
				<Tag color="red" className="!whitespace-normal">
					Chưa gửi: {REASON_TEXT[reason] || "gửi thất bại"}
				</Tag>
			) : (
				<Tag>Chưa gửi</Tag>
			)}
			<div className="flex gap-1">
				<Popconfirm
					title={status === "sent" ? "Gửi lại ZNS?" : "Gửi ZNS ngay?"}
					description={`${record?.ten_kh ?? ""} (${record?.ma_kh ?? ""})`}
					okText="Gửi"
					cancelText="Hủy"
					onConfirm={handleSend}
				>
					<Button
						size="small"
						loading={sending}
						className={status === "sent" ? "" : "btn_primary"}
					>
						{status === "sent" ? "Gửi lại" : "Gửi"}
					</Button>
				</Popconfirm>
				{status === "failed" && PHONE_REASONS.includes(reason) && (
					<Button size="small" onClick={openEditPhone}>
						Sửa SĐT
					</Button>
				)}
			</div>

			<Modal
				open={!!editingPhone}
				title={`Sửa SĐT - ${record?.ten_kh ?? ""} (${record?.ma_kh ?? ""})`}
				okText="Lưu và gửi lại"
				cancelText="Hủy"
				confirmLoading={savingPhone}
				onOk={handleSavePhoneAndSend}
				onCancel={() => setEditingPhone(null)}
			>
				<div
					className="flex flex-col gap-2"
					onClick={(e) => e.stopPropagation()}
				>
					<Input
						value={phoneInput}
						onChange={(e) => setPhoneInput(e.target.value)}
						onPressEnter={handleSavePhoneAndSend}
						placeholder="Ví dụ 0707261102"
					/>
					{phoneInput && !isValidVnMobile(phoneInput) && (
						<span className="text-red-500 text-sm">SĐT không hợp lệ</span>
					)}
					<span className="text-xs text-gray-500">
						SĐT được ghi thẳng vào hồ sơ khách hàng, sau đó gửi lại ZNS.
					</span>
				</div>
			</Modal>
		</div>
	);
}
